module.exports = __webpack_public_path__ + "img/home.0060c60c.png";